import { IonItem } from "@ionic/react";
import { ComponentProps } from "react";
import { FormattedMessage } from "react-intl";

import IconBase from "@components/text/IconBase";
import BodyCopy from "@components/typography/BodyCopy";
import { IconName } from "@utils/iconUtils";

type Props = Pick<ComponentProps<typeof IonItem>, "disabled" | "lines" | "onClick" | "routerLink"> & {
  icon: IconName;
  iconColor?: "primary" | "success-500";
  textKey: string;
};

const PopoverItem = ({ icon, iconColor = "primary", textKey, ...ionItemProps }: Props) => (
  <IonItem lines="full" {...ionItemProps} button={!!ionItemProps.onClick && !ionItemProps.routerLink}>
    <IconBase color={iconColor} icon={icon} slot="start" />
    <BodyCopy color="primary" size="small">
      <FormattedMessage id={textKey} />
    </BodyCopy>
  </IonItem>
);

export default PopoverItem;
